import React from 'react';
import ListPageLayout from '@layouts/ListPageLayout';
import {withRouter} from 'react-router'

import AgentFilterForm from './AgentFilterForm';
import AgentListTable from './AgentListTable';
import AgentModal from './AgentModal';

import update_to_agent_store, {filter_store} from '@store/Agent/UpdateToAgentStore';

import breadcrumb_store from '@src/Store/Common/MyBreadcrumb';
import login_user_store from '@src/Store/LoginUser/LoginUserStore';

@withRouter
class AgentList extends React.PureComponent {

    constructor(props) {
        super();


        let state = props.location.state;
        let id = props.match.params.id;
        let username = props.match.params.username;

        this.updateDatas(state, id, username);
    }

    componentWillReceiveProps(props) {
        let state = props.location.state;
        let id = props.match.params.id;
        let username = props.match.params.username;

        this.updateDatas(state, id, username);
    }

    updateDatas(state, id, username) {
        if (state == undefined) {
        } else {
            filter_store.setAttr(state)
        }

        if (id == login_user_store.id) {
            breadcrumb_store.resetProxy(id, username);
        } else {
            breadcrumb_store.addProxyItem(id, username)
        }
    }

    showAddNewAgentModal = () => {
        update_to_agent_store.openModal();
    }

    render() {
        return (
            <ListPageLayout
                isCustomHeader
                header={
                    <AgentFilterForm/>
                }
                list={
                    <AgentListTable/>
                }
                modal={
                    <AgentModal/>
                }
            />
        );
    }
}

export default AgentList;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/Agent/AgentList/AgentList.jsx